export default __webpack_public_path__ + "static/clouds-fe9768eb70a5bb3cb0ff6bf78e36cfaf.png";